import styled from 'styled-components'

export const ContentWrapper = styled.div`
  padding: 0px 0px 0px 0px;
  width: 100%;
  height: fit-content;
  background-color: ${({ theme }) => theme.colors.backgroundLite};
`
